// used in Dashboard
angular.module('cfn').factory('cropPlanningChartService', [
  '$log',
  '$filter',
  'i18nFilter',
  'unitConverter',
  'userSettingsService',
  'numberFilter',
  function(
    $log,
    $filter,
    i18nFilter,
    unitConverter,
    userSettingsService,
    numberFilter
  ) {
    var drawCulturesChart = function(
      culturesChart,
      cultureAggr,
      cultureMap,
      chartTitle,
      highlightCulture,
      chartOptions,
      selectable
    ) {
      if (cultureMap) cultureMap.length = 0; // clear array
      var table = [['Culture', 'Farmed Area']];
      var slices = [];

      var series = [];
      var userAreaUnit = userSettingsService.getAreaUnitEnum();

      $.each(cultureAggr, function(cultureId, v) {
        if (v.farmedArea > 0) {
          var curOb = {
            name: v.displayName,
            y: preciseRound(
              unitConverter.convert('AREAL_HA', userAreaUnit, v.farmedArea),
              unitConverter.unitDefaultDecimals(userAreaUnit)
            ),
            sliced: false,
            color: v.color
          };

          series.push(curOb);

          var slice = { color: v.color };
          // Highlight current fruit
          if (cultureId === highlightCulture) {
            slice.offset = 0.2;
            curOb.sliced = true;
          }
          //slices.push(slice);
          if (cultureMap) cultureMap.push(cultureId);
        }
      });

      this.drawPieChart(culturesChart, series, chartTitle, selectable);
    };

    function getPieChartData(cultureAggr) {
      var series = [];
      var userAreaUnit = userSettingsService.getAreaUnitEnum();
      $.each(cultureAggr, function(cultureId, v) {
        if (v.workedArea > 0) {
          var curOb = {
            name: v.abbreveation,
            fullName: v.name,
            y: preciseRound(
              unitConverter.convert('AREAL_HA', userAreaUnit, v.workedArea),
              unitConverter.unitDefaultDecimals(userAreaUnit)
            ),
            sliced: false,
            color: v.colour
          };

          if (!v.id) {
            curOb.name = i18nFilter('fe.dashboard.noCrop', 'No crop');
            curOb.fullName = i18nFilter('fe.dashboard.noCrop', 'No crop');
            curOb.color = '#C7C7C7';
          }

          series.push(curOb);
        }
      });

      return series;
    }

    /**
     * Draws a pie chart via highcharts
     * @param {object} jquery element target
     * @param {string} cultureId UUID or NO_FRUIT
     * @param {boolean} overhang if true, only overhang is shown, else only regular crop
     * @param {string} chartTitle caption of chart
     * @param {object} chartOptions additional options for chart (e.g. legend)
     */
    var drawPieChart = function(chart, series, chartTitle, selectable) {
      if (!chart) return; // don't draw anything if element is not selected
      var userAreaUnit = userSettingsService.getAreaUnit();
      var userAreaUnitEnum = userSettingsService.getAreaUnitEnum();
      var ctrl = this;
      var colors = [];
      for (var i = 0; i < series.length; i++) {
        colors.push(series[i].color);
        // Delete original colors, so that new radialized are used
        delete series[i].color;
      }

      // Use color array and radialize each color
      var radientColors = Highcharts.map(colors, function(color) {
        return {
          linearGradient: { x1: 0, y1: 0, x2: 1, y2: 0 },
          stops: [
            [0, color],
            [
              1,
              Highcharts.Color(color)
                .brighten(-0.1)
                .get('rgb')
            ] // darken
          ]
        };
      });

      /*        google.visualization.events.addListener(controller.chartRegularCulture, 'select',
                function() { controller.onCultureChartSelect(false); } );
            google.visualization.events.addListener(controller.chartOverhangCulture, 'select',
                function() { controller.onCultureChartSelect(true); } );
*/
      /* pointFormat is available up version 4.1 */
      chart.highcharts({
        chart: {
          backgroundColor: 'rgba(255,255,255,0.002)',
          spacing: [1, 1, 1, 1],
          stickyTracking: true,
          slicedOffset: 4,
          reflow: true
        },
        title: {
          text: '' //chartTitle
        },
        tooltip: false,
        legend: {
          padding: 4,
          backgroundColor: '#f1f1f1',
          borderColor: '#f1f1f1',
          symbolHeight: 10,
          symbolWidth: 10,
          symbolRadius: 10,
          itemStyle: {
            color: '#666',
            fontSize: '11px'
          }
        },
        plotOptions: {
          pie: {
            allowPointSelect: selectable,
            colors: radientColors,
            startAngle: 90,
            showInLegend: false,
            events: {
              click: function(event) {
                if (selectable) selectable(chart, event.point.x);
              }
            },
            dataLabels: {
              backgroundColor: 'rgba(255,255,255,0.5)',
              inside: true,
              distance: 10,
              enabled: true,
              color: '#000000',
              connectorColor: '#cccccc',
              style: 'text-align:center',
              formatter: function() {
                return (
                  '' +
                  this.point.name +
                  '<br>' +
                  '<span style="color: #777777">' +
                  numberFilter(
                    this.y,
                    unitConverter.unitDefaultDecimals(userAreaUnitEnum)
                  ) +
                  ' ' +
                  userAreaUnit +
                  '</span>'
                );
              }
            }
          }
        },
        credits: {
          enabled: false
        },
        series: [
          {
            type: 'pie',
            name: 'Anteil',
            data: series
          }
        ]
      });
    };

    /**
     * Draws a variety chart
     * @param {object} seedChart chart object to update
     * @param {string} cultureId UUID or NO_FRUIT
     * @param {boolean} overhang if true, only overhang is shown, else only regular crop
     * @param {string} chartTitle caption of chart
     * @param {object} chartOptions additional options for chart (e.g. legend)
     */
    var drawVarietyChart = function(
      seedChart,
      cultureId,
      overhang,
      details,
      chartTitle,
      chartOptions,
      noFruitName
    ) {
      var varietyAggr = {};
      var NO_FRUIT = '';
      var noFruit = { displayName: noFruitName, cropArea: 0, color: '#ccc' };
      $.each(details, function(k, detail) {
        // Show either only regular or only overhang
        if (
          (overhang && !detail.isOverhang) ||
          (!overhang && detail.isOverhang)
        )
          return;

        // Does culture match or are we regarding fields without fruit?
        if (
          (detail.abbrFruit && detail.abbrFruit.id === cultureId) ||
          (!detail.abbrFruit && cultureId === NO_FRUIT)
        ) {
          var varietySum = 0;
          $.each(detail.varietyDetails, function(vk, varietyDetail) {
            // This happens temporary
            if (!varietyDetail.variety.sysSeed) return;

            if (!(varietyDetail.variety.id in varietyAggr)) {
              varietyAggr[varietyDetail.variety.id] = {
                displayName: varietyDetail.variety.sysSeed.name,
                cropArea: 0.0,
                color: varietyDetail.variety.sysSeed.sysCulture.colour
              };
            }
            var aggrRow = varietyAggr[varietyDetail.variety.id];
            aggrRow.cropArea += varietyDetail.cropArea;
            varietySum += varietyDetail.cropArea;
          });

          if (varietySum < detail.farmedArea) {
            noFruit.cropArea += detail.farmedArea - varietySum;
          }
        }
      });
      if (noFruit.cropArea > 0) {
        varietyAggr[NO_FRUIT] = noFruit;
      }

      var userAreaUnit = userSettingsService.getAreaUnitEnum();
      var series = [];
      $.each(varietyAggr, function(varietyId, variety) {
        var curOb = {
          name: variety.displayName,
          y: preciseRound(
            unitConverter.convert('AREAL_HA', userAreaUnit, variety.cropArea),
            unitConverter.unitDefaultDecimals(userAreaUnit)
          ),
          sliced: false,
          color: variety.color
        };

        series.push(curOb);
      });
      this.drawPieChart(seedChart, series, chartTitle, false);
    };
    return {
      drawCulturesChart: drawCulturesChart,
      drawPieChart: drawPieChart,
      drawVarietyChart: drawVarietyChart,
      getPieChartData: getPieChartData
    };
  }
]);
